<div class="powered-by {{tema}}" *ngIf="exibirPoweredBy" >
    <i class="fas fa-heart" style=""></i>
    <a href="https://meucardapio.ai" target="_blank" style="  text-decoration: none;">
      Feito por &nbsp;<img src="https://fibo.promokit.com.br/lp/cardapio/images/logo-meucardapio.png" style="width: 45px;"/> </a>
    <i class="fas fa-sparkles" style=""></i>
</div>
